// extracted by mini-css-extract-plugin
var _1 = "BirdviewCardHeader-moduleaiTitle__LSm7O";
var _2 = "BirdviewCardHeader-moduleheader__kC2sf";
var _3 = "BirdviewCardHeader-moduletitle__AcDdY";
var _4 = "BirdviewCardHeader-moduletitleWrap__xHKLQ";
export { _1 as "aiTitle", _2 as "header", _3 as "title", _4 as "titleWrap" }
